// extracted by mini-css-extract-plugin
export default {"form":"style_form__b5g03","formInputContainer":"style_formInputContainer__w1nUe","errorText":"style_errorText__JDSw4","submit":"style_submit__jsbKA","mb0":"style_mb0__-AP2S"};